module.exports = __webpack_public_path__ + "img/pdf-ic.b1413df4.svg";